<table
    class="table-view"
    *ngIf="objectFiles">
    <tr>
        <th>File</th>
        <th>Amount</th>
        <th class="td-small"></th>
    </tr>

    <tr *ngFor="let file of objectFiles">
        <td>
            <app-pill-global-file [file]="file"></app-pill-global-file>
        </td>
        <td>
            {{ file.amountExcl | currency: 'EUR' }}
        </td>
        <td>
            <a
                class="color--red"
                (click)="remove(file)"
                >Remove</a
            >
        </td>
    </tr>

    <tr>
        <td
            colspan="4"
            class="table-view__add"
            (click)="openAddModal()">
            <i class="las la-plus"></i> Add file
        </td>
    </tr>
</table>
